var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInusedTableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 114,
    viewBox: "0 0 115 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.585938,
    width: 113.583,
    height: 113.583,
    fill: "#2E3E54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInusedTableIcon);
export default __webpack_public_path__ + "static/media/inused-table-icon.d58231d46dea641c997fd33f873b79cb.svg";
export { ForwardRef as ReactComponent };